export default __webpack_public_path__ + "static/media/wheelIcon.3dcbac10.svg";